module.exports = __webpack_public_path__ + "img/selected7-min.0ed4f719.png";